import { webApi } from "../../../../core/http/httpThunks";
import { ProductList } from "../types";

export const getAllProductsApi = (userId: string) =>
	webApi<ProductList[]>({
		method: "GET",
		url: "listing/getprodlist",
		params: {
			userId,
		},
	});

export default getAllProductsApi;
